var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 16.6667C13.6819 16.6667 16.6666 13.6819 16.6666 10C16.6666 6.31812 13.6819 3.33335 9.99996 3.33335C6.31806 3.33335 3.33329 6.31812 3.33329 10C3.33329 13.6819 6.31806 16.6667 9.99996 16.6667ZM9.99996 18.3334C14.6023 18.3334 18.3333 14.6024 18.3333 10C18.3333 5.39765 14.6023 1.66669 9.99996 1.66669C5.39758 1.66669 1.66663 5.39765 1.66663 10C1.66663 14.6024 5.39758 18.3334 9.99996 18.3334Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 8.33331C9.99996 7.87308 10.373 7.49998 10.8333 7.49998H11.6666C12.1269 7.49998 12.5 7.12689 12.5 6.66665C12.5 6.20641 12.1269 5.83331 11.6666 5.83331H10.8333C9.45254 5.83331 8.33329 6.9526 8.33329 8.33331V9.99998H7.49996C7.03973 9.99998 6.66663 10.3731 6.66663 10.8333C6.66663 11.2936 7.03972 11.6666 7.49996 11.6666H8.33329V16.6666C8.33329 17.1269 8.70638 17.5 9.16663 17.5C9.62688 17.5 9.99996 17.1269 9.99996 16.6666V11.6666H11.6666C12.1269 11.6666 12.5 11.2936 12.5 10.8333C12.5 10.3731 12.1269 9.99998 11.6666 9.99998H9.99996V8.33331Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.72806ee2bfe091e6d634aa1853ca528b.svg";
export { ForwardRef as ReactComponent };